import authConstants from '../../auth/authConstants';

const { AUTH_STATE_KEY, ACTIVITY_SYNC_KEY } = authConstants;

const isHtmlResponse = (data: unknown): boolean =>
  typeof data === 'string' && /<!doctype html>/i.test(data);

const isInactiveSessionResponse = (data: unknown): boolean =>
  typeof data === 'object' &&
  data !== null &&
  'active' in data &&
  (data as { active: boolean }).active === false;

const hasApiReturnedExpiredResponse = (
  data: unknown,
  sessionStore: { setIsAuthenticated: (value: boolean | null) => void; setWarningTime?: (value: number) => void; setSessionExpiry?: (value: number) => void; setLastActivityTime?: (value: string | null) => void; setUser?: (value: Record<string, unknown> | null) => void },
  navigate?: (path: string) => void
): boolean => {
  if (isHtmlResponse(data) || isInactiveSessionResponse(data)) {
      sessionStore.setIsAuthenticated(false);
      if (sessionStore.setWarningTime) sessionStore.setWarningTime(0);
      if (sessionStore.setSessionExpiry) sessionStore.setSessionExpiry(0);
      if (sessionStore.setLastActivityTime) sessionStore.setLastActivityTime(null);
      if (sessionStore.setUser) sessionStore.setUser(null);
      localStorage.setItem(AUTH_STATE_KEY, 'logged-out');
      localStorage.removeItem(ACTIVITY_SYNC_KEY);
      if (navigate) navigate('/');
      return true;
  }
  return false;
};

export default hasApiReturnedExpiredResponse;
